import PropTypes from "prop-types"
import { capitalize, chain, countBy } from "lodash"
import { Paper } from "@mui/material"
import Table from "components/material/table"
import { UUID, ROLE, REPORT_ENTITY } from "helpers/shapes"
import { makeSourcesElementRender } from "helpers/datasets"
import pluralize from "pluralize"
import UpsellTabs, { UPSELL_TABS_SHAPE } from "components/material/upsell-tabs"

export default function DatasetReport({ account, role, datasetEntities, tabs }) {
  const { member: nbMembers, token: nbTokens } = countBy(datasetEntities, ({ type }) => type)
  // Make sure we always display the title correctly
  const title = chain([
    nbMembers > 0 && `${nbMembers} ${pluralize("member", nbMembers)}`,
    nbTokens > 0 && `${nbTokens} ${pluralize("token", nbTokens)}`,
  ])
    .compact()
    .join(", ")
    .value()

  return <div className="modules_dataset-entitlements-report">
    {role === "admin" && <UpsellTabs id="dataset-report" tabs={tabs} />}
    <Paper className="content" square>
      <Table
        title={title}
        idField="id"
        addForm={false}
        editForm={null}
        deleteForm={null}
        data={datasetEntities}
        columns={[{
          name: "Name",
          id: "name",
          linkTo: ({ id, type }) => role === "admin" && `/${account}/home/${type}s/${id}/entitlements`,
        },
        {
          name: "Type",
          id: "type",
          render: ({ type }) => capitalize(type),
        },
        {
          name: "Sources",
          id: "sources",
          render: makeSourcesElementRender(account),
        }]}
      />
    </Paper>
  </div>
}

DatasetReport.propTypes = {
  account: PropTypes.string.isRequired,
  datasetId: PropTypes.string.isRequired,
  userId: UUID,
  role: ROLE.isRequired,
  datasetEntities: PropTypes.arrayOf(REPORT_ENTITY).isRequired,
  update: PropTypes.func.isRequired,
  tabs: UPSELL_TABS_SHAPE,
}
